import { update } from "../utils";
import apis from "@/apis";
import i18n from "@/lang";
import elLocale from "element-ui/lib/locale";

import cnLocale from "element-ui/lib/locale/lang/zh-CN";
import hkLocale from "element-ui/lib/locale/lang/zh-TW";
import enLocale from "element-ui/lib/locale/lang/en";

export default {
  namespaced: true,
  state: {
    marquee: "",
    onlineAgent: 0,
    onlineMember: 0,
    user: {
      username: "",
      privileges: {},
      group: 0,
      isSub: false,
      isAdmin: false,
      lang: "zh-cn",
      token: "",
      id: "",
      permissions: {},
      merchantCode: "",
    },
    lang: {
      key: "",
      message: null,
    },
    menu: [],
    menuDrawerStatus: false,
    menuCollapse: false,
    badge: {
      assistence: 0,
    },
    langList: [
      {
        lang_code: "zh-cn",
        lang_display: "简体中文",
      },
    ],
    url: {
      mobile: [],
      pc: [],
    },
    site: "",
    enableThirdParty: false,
    demo: null,
    theme: "",
    earningsStatistic: [],
    showHeaderPaper: false,
    timer: 900,
    intervalId: null,
    isNotice: false,
  },
  actions: {
    fetch(context) {
      return apis.app.getInfo().then((response) => {
        context.commit("update", response.data);
        return Promise.resolve(response);
      });
    },
    fetchLang(context, data = null) {
      return new Promise((resolve) => {
        apis.app.getLang(data).then((response) => {
          let langues = {};
          if (response.data.struct == true) {
            langues = response.data.langues;
          } else {
            Object.keys(response.data.langues).forEach((lang_code) => {
              langues[lang_code] = response.data.langues[lang_code].reduce(
                (a, c) => {
                  a[c.content_code] = c.content;

                  if (c.content_code == "title.site") {
                    a[c.content_code] = response.data.siteTitle;
                  }
                  return a;
                },
                {}
              );
            });
          }

          let lang = {
            key: response.data.lang_code,
            message: langues,
          };
          document.cookie = "lang_code=" + response.data.lang_code;
          document.title = response.data.siteTitle;
          document
            .querySelector("body")
            .setAttribute("data-site", response.data.siteTitle);
          document
            .querySelector("body")
            .classList.add(
              response.data.theme.length > 0
                ? "theme-" + response.data.theme
                : "blue"
            );
          context.commit("update", {
            site: response.data.siteTitle,
            demo: response.data.demo ?? null,
            theme: response.data.theme,
          });
          context.commit("updateLang", lang);
          return resolve(response);
        });
      });
    },
    fetchLangList(context) {
      return apis.dropdown.getLangList().then((response) => {
        context.commit("updateLangList", response.data);
        return Promise.resolve(response.data);
      });
    },
    logout(context) {
      apis.logout().then(() => {
        context.commit("update", { user: { username: "", lang: "zh-cn" } });
        context.commit("CLEAR_INTERVAL_ID");
        context.commit("RESET_TIMER");
      });
    },
    countdown({ commit, state }) {
      if (state.intervalId) return;

      const intervalId = setInterval(() => {
        commit("DECREASE_TIMER");

        if (state.timer === 0) {
          commit("RESET_TIMER");
        }
      }, 1000);

      commit("SET_INTERVAL_ID", intervalId);
    },
    stopCountdown({ commit }) {
      commit("CLEAR_INTERVAL_ID");
    },
  },
  mutations: {
    update,
    updateLang(state, lang) {
      state.lang = lang;
      i18n.locale = lang.key;
      i18n.mergeLocaleMessage("zh-cn", lang.message["zh-cn"]);
      i18n.mergeLocaleMessage(lang.key, lang.message[lang.key]);
      // 更新第三方元件庫語系
      switch (lang.key) {
        case "zh-hk":
          elLocale.use(hkLocale);
          break;
        case "en-us":
          elLocale.use(enLocale);
          break;
        case "zh-cn":
        default:
          elLocale.use(cnLocale);
          break;
      }
    },
    updateLangList(state, langList) {
      state.langList = langList;
    },
    TOGGLE_MENU_DRAWER(state, status) {
      if (typeof status == "undefined") {
        status = !state.menuDrawerStatus;
      }
      state.menuDrawerStatus = status;
    },
    TOGGLE_MENU_COLLAPSE(state, status) {
      if (typeof status == "undefined") {
        status = !state.menuCollapse;
      }
      state.menuCollapse = status;
    },
    update_badge(state, { name, diff }) {
      if (name in state.badge) {
        state.badge[name] = parseInt(state.badge[name]) + parseInt(diff);
      }
    },
    DECREASE_TIMER(state) {
      state.timer--;
    },

    RESET_TIMER(state) {
      state.timer = 900;
    },

    SET_INTERVAL_ID(state, id) {
      state.intervalId = id;
    },

    CLEAR_INTERVAL_ID(state) {
      if (state.intervalId) {
        clearInterval(state.intervalId);
        state.intervalId = null;
      }
    },
    SHOW_BEEP(state, status) {
      state.isNotice = status;
    },
  },
  getters: {
    token: (state) => {
      return state.user.token;
    },
    user: (state) => {
      return state.user;
    },
    logined: (state) => {
      return state.user.username && state.user.username.length > 0;
    },
    siteTitle: (state) => {
      return state.site;
    },
    timer: (state) => {
      return state.timer;
    },
    isNotice: (state) => {
      return state.isNotice;
    },
  },
};
